import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { UserPlus, LogIn, ArrowLeft } from "lucide-react";
import logoImage from "@/assets/logo-corre-digital.png";

export default function AlunoEscolha() {
  const navigate = useNavigate();
  const next = new URLSearchParams(window.location.search).get("next");
  const nextParam = next ? `?next=${encodeURIComponent(next)}` : "";
  return (
    <div className="min-h-screen bg-background flex flex-col px-6 py-8">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        className="flex items-center gap-4 mb-8"
      >
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate("/aluno/landing")}
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <img src={logoImage} alt="Corre Digital" className="h-8" />
      </motion.div>

      {/* Content */}
      <div className="flex-1 flex flex-col justify-center max-w-md mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-center mb-10"
        >
          <h1 className="font-heading text-2xl font-bold text-foreground mb-2">
            Como você quer continuar?
          </h1>
          <p className="text-muted-foreground">
            Em poucos passos você entra na comunidade.
          </p>
        </motion.div>

        <div className="space-y-4">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <Button
              variant="default"
              size="xl"
              className="w-full justify-start gap-4"
              onClick={() => navigate(`/aluno/cadastro${nextParam}`)}
            >
              <div className="w-10 h-10 rounded-xl bg-primary-foreground/20 flex items-center justify-center">
                <UserPlus className="w-5 h-5" />
              </div>
              <div className="text-left">
                <p className="font-semibold">Criar meu perfil</p>
                <p className="text-xs opacity-80 font-normal">Novo por aqui? Comece agora</p>
              </div>
            </Button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <Button
              variant="outline"
              size="xl"
              className="w-full justify-start gap-4"
              onClick={() => navigate(`/aluno/login${nextParam}`)}
            >
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                <LogIn className="w-5 h-5 text-primary" />
              </div>
              <div className="text-left">
                <p className="font-semibold text-foreground">Já tenho cadastro</p>
                <p className="text-xs text-muted-foreground font-normal">
                  Entrar com e-mail ou telefone
                </p>
              </div>
            </Button>
          </motion.div>
        </div>

        {/* Footer message */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-12 p-4 bg-accent/10 rounded-2xl border border-accent/20"
        >
          <p className="text-sm text-center text-foreground font-medium">
            "Você não precisa estar pronto. Precisa estar comprometido."
          </p>
        </motion.div>
      </div>
    </div>
  );
}
